// extracted by mini-css-extract-plugin
export default {"body-1":"g__body-1--vQFVJ","current-user-bid":"g__current-user-bid--KJr4I","tooltip-label":"g__tooltip-label--NdKSE","tooltip-icon":"g__tooltip-icon--ArN6n"};